[
  {
    "active": true,
    "completed": false,
    "heading": "Uninsured/Underinsured Motorist",
    "flowId": "uimui",
    "substeps": [
      {
        "active": false,
        "completed": false,
        "heading": "Digital Signature Consent",
        "flowId": "uimui",
        "route": "uimui-consent"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Selection of Coverages",
        "flowId": "uimui",
        "route": "uimui-selection"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Review State Selections",
        "flowId": "uimui",
        "route": "uimui-review-state"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Outstanding State Selections",
        "flowId": "uimui",
        "route": "uimui-outstanding-state"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Electronic Signature",
        "flowId": "uimui",
        "route": "uimui-signature"
      }
    ]
  },
  {
    "active": false,
    "completed": false,
    "heading": "Personal Injury Protection",
    "flowId": "pip",
    "substeps": [
      {
        "active": false,
        "completed": false,
        "heading": "Digital Signature Consent",
        "flowId": "pip",
        "route": "pip-consent"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Selection of Coverages",
        "flowId": "pip",
        "route": "pip-selection"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Review State Selections",
        "flowId": "pip",
        "route": "pip-review-state"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Outstanding State Selections",
        "flowId": "pip",
        "route": "pip-outstanding-state"
      },
      {
        "active": false,
        "completed": false,
        "heading": "Electronic Signature",
        "flowId": "pip",
        "route": "pip-signature"
      }
    ]
  }
]